import { defineMessages } from "react-intl";

export const messages = defineMessages({
  giveFeedback: {
    id: "rovo-extension.feedback.give-feedback-button.label",
    defaultMessage: "Give feedback",
    description: "Label for the button to give feedback.",
  },
  feedbackCollectorLabel: {
    id: "rovo-extension.feedback.feedback-collector.label",
    defaultMessage: "Let us know what's on your mind",
    description: "Label for the feedback collector.",
  },
  areYouEnjoying: {
    id: "rovo-extension.feedback.are-you-enjoying.label",
    defaultMessage: "Are you enjoying the Rovo Chrome plugin?",
    description: "Label for the question asking if the user is enjoying the Rovo Chrome plugin.",
  },
  shareYourThoughts: {
    id: "rovo-extension.feedback.share-your-thoughts.label",
    defaultMessage: "Share your thoughts",
    description: "Label for the title of the feedback modal.",
  },
  yes: {
    id: "rovo-extension.feedback.yes.label",
    defaultMessage: "Yes",
    description: "Label for the 'Yes' button in the feedback modal.",
  },
  no: {
    id: "rovo-extension.feedback.no.label",
    defaultMessage: "No",
    description: "Label for the 'No' button in the feedback modal.",
  },
  reviewConfirmationTitle: {
    id: "rovo-extension.feedback.review-confirmation-title",
    defaultMessage: "Thanks for the feedback!",
    description: "Title for the review step shown in the feedback flag after user clicks Yes.",
  },
  reviewConfirmationBody: {
    id: "rovo-extension.feedback.review-confirmation-body",
    defaultMessage: "Want to leave a quick review in the Chrome Web Store?",
    description: "Body text for the review step asking user to leave a Chrome Web Store review.",
  },
  reviewConfirmationConfirm: {
    id: "rovo-extension.feedback.review-confirmation-confirm",
    defaultMessage: "Leave a review",
    description: "Label for the confirm button in the review step that opens Chrome Web Store.",
  },
  reviewConfirmationDismiss: {
    id: "rovo-extension.feedback.review-confirmation-dismiss",
    defaultMessage: "Not now",
    description: "Label for the dismiss button in the review step of the feedback flag.",
  },
});
